module.exports = __webpack_public_path__ + "static/media/calendar.5ef11315.svg";